import clsx from 'clsx';
import { ReactNode } from 'react';
import { Dropdown, DropdownProps } from 'react-bootstrap';
import PrintButton from '../button-in-phieu';
import { PrintButtonProps } from '../button-in-phieu/types';

type Props = {
	config: PrintButtonProps<any>[];
	grouped?: boolean;
	label?: ReactNode;
	dropdownProps?: DropdownProps;
};

const PrintButtonGroup = ({ config, grouped, label, dropdownProps }: Props) => {
	// If grouped is explicitly set, use that behavior
	// Otherwise, render both and let CSS handle responsive display
	if (grouped === true) {
		return (
			<Dropdown {...dropdownProps}>
				<Dropdown.Toggle variant="primary" className="btn-flex">
					{label ? (
						label
					) : (
						<span>
							<i className="bi bi-printer"></i>
							In phiếu
						</span>
					)}
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{config.map((btn, index) => (
						<Dropdown.Item className="py-2" key={index}>
							<PrintButton
								{...btn}
								isOnlyText
								className={clsx('d-inline-block w-100 h-100', btn.className)}
							/>
						</Dropdown.Item>
					))}
				</Dropdown.Menu>
			</Dropdown>
		);
	}

	if (grouped === false) {
		return (
			<div className="d-flex gap-2">
				{config.map((btn, index) => (
					<PrintButton key={index} {...btn} />
				))}
			</div>
		);
	}

	// grouped is undefined - render both with responsive CSS
	return (
		<>
			{/* Show dropdown on screens < 1920px (HD) */}
			<Dropdown {...dropdownProps} className="print-button-group-dropdown">
				<Dropdown.Toggle variant="primary" className="btn-flex">
					{label ? (
						label
					) : (
						<span>
							<i className="bi bi-printer"></i>
							In phiếu
						</span>
					)}
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{config.map((btn, index) => (
						<Dropdown.Item className="py-2" key={index}>
							<PrintButton
								{...btn}
								isOnlyText
								className={clsx('d-inline-block w-100 h-100', btn.className)}
							/>
						</Dropdown.Item>
					))}
				</Dropdown.Menu>
			</Dropdown>

			{/* Show separate buttons on screens >= 1920px (HD) */}
			<div className="print-button-group-buttons d-none gap-2">
				{config.map((btn, index) => (
					<PrintButton key={index} {...btn} />
				))}
			</div>
		</>
	);
};

export default PrintButtonGroup;
